import {Component, input, Input, OnInit} from '@angular/core';
import {Size} from "../../types/size.type";
import {CurrentWeather} from "../../model/weather.model";
import {WeatherService} from "../../service/weather.service";
import {CalcWeatherIconParams} from "../../model/calc-weather-icon-params.interface";

@Component({
  selector: 'app-weather-icon',
  templateUrl: './weather-icon.component.html',
  styleUrls: ['./weather-icon.component.scss'],
})
export class WeatherIconComponent implements OnInit {

  @Input() params: CalcWeatherIconParams;
  @Input() size: Size = 'normal';

  id = input<string>();
  class = input<string>('');

  isMoon: boolean;
  path: string;

  constructor(private weatherService: WeatherService) {
  }

  ngOnInit() {
    this.path = this.weatherService.calculateWeatherStyle(this.params).icon;
    this.isMoon = this.path.includes('moon.png');
  }

}




